import { createSelector } from 'reselect';
import { State } from '../../types/mx/reducers';
import {EMPTY_CATALOG} from '../../constants/GlobalConstants';

export const relationshipTypeSelector = createSelector(
    (state: State) => state.catalogs.employmentTypes,
    (state: State) => state.creditoReal.loanApplication.applicantEmployment.employmentRelationshipTypeId,
    (employmentTypes, employmentRelationshipTypeId) =>
        employmentTypes?.find(i => i.id === employmentRelationshipTypeId) || EMPTY_CATALOG
);
